export const imgUrl = {
   w_og: "https://image.tmdb.org/t/p/original",
   w_200: "https://image.tmdb.org/t/p/w200",
};
